import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Popover,
  CardHeader,
  CardActions,
  Divider,
  Button,
  colors,
  LinearProgress,
  CircularProgress
} from '@material-ui/core';
import NotificationList from './NotificationList';
import Placeholder from './Placeholder';
import { Trans } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    width: 350,
    maxWidth: '100%',
  },
  actions: {
    backgroundColor: colors.grey[50],
    justifyContent: 'center'
  }
}));

function NotificationsPopover({ notifications, loading, loadMoreActive, handleLoadMore, anchorEl, ...rest }) {
  const classes = useStyles();

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      style={{zIndex: 6001}}
    >
      <div className={classes.root}>
        <CardHeader title="Notifications" />
        <Divider />
        {notifications.length > 0 ? (
          <NotificationList notifications={notifications}/>
        ) : loading ? (<LinearProgress />): undefined }
        { notifications.length === 0 ? <Placeholder /> : undefined }
        {loading && notifications.length > 0 && <LinearProgress />}
        <Divider />
        <CardActions className={classes.actions}>
          <Button
            size="small"
            onClick={() => handleLoadMore()}
            disabled={!loadMoreActive}
          >
            <Trans>frontend.components.chat.load_more</Trans>
          </Button>
        </CardActions>
      </div>
    </Popover>
  );
}

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default NotificationsPopover;
